module.exports = __webpack_public_path__ + "static/media/Physiofit-9.72fc31d2.jpg";